import { chakra, EloButton } from '@plurall/elo-v3';

import { benchmarkingMecActionButtonRecipe, benchmarkingMecActionsRecipe } from './BenchmarkingMecEmptyState.recipe';

export const BenchmarkingMecActionButtonFactory = chakra(EloButton.Brand, benchmarkingMecActionButtonRecipe);
export const BenchmarkingMecActionsFactory = chakra('div', benchmarkingMecActionsRecipe);
